import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Auditoria } from './Auditoria';
import { LogsErros } from './LogsErros';
import { HistoricoTelas } from './HistoricoTelas';
import { Modulos } from './Modulos';
import { Painel } from './Painel';
import { Saude } from './Saude';
import { TelaEntrada } from './TelaEntrada';
import { UsoIa } from './UsoIa';
import { Tenants } from './Tenants';
import { Usuarios } from './Usuarios';
import { ConviteModal } from './Convites';
import { i18n } from './i18n';

const modulo: ModuloWeb = {
  slug: 'admin',
  menu: 'admin',
  ordem: 10,
  abas: [
    { chave: 'painel', permissao: 'admin.ver', componente: Painel },
    { chave: 'modulos', permissao: 'admin.modulos', componente: Modulos },
    { chave: 'tenants', permissao: 'admin.tenants', componente: Tenants },
    // Lote de 21/10 (item 4): "Usuários e acessos" mora em Pessoas > Pessoas (aba projetada; dado, API e permissão seguem do
    // Admin). Depois das abas do Pessoas, que não têm posição (1000 + a ordem delas).
    { chave: 'usuarios', permissao: 'admin.usuarios', componente: Usuarios, menu: 'pessoas', grupo: 'pessoas', posicao: 1900 },
    { chave: 'auditoria', permissao: 'admin.auditoria', componente: Auditoria },
    { chave: 'saude', permissao: 'admin.ver', componente: Saude },
    // CRM no novo desenho, lote 0: log de erros das telas (tabela e permissão do núcleo, `nucleo.erros.ver`).
    { chave: 'erros', permissao: 'nucleo.erros.ver', componente: LogsErros },
    // Fase 2 (W37): o comparativo "antes e depois" das telas; só o administrador da plataforma (o conteúdo é da instalação).
    { chave: 'historico-telas', permissao: 'admin.ver', plataforma: true, componente: HistoricoTelas },
    // Tela de entrada (30/10): logo e fundo do login e da saída; da instalação inteira, só o administrador da plataforma.
    { chave: 'tela-entrada', permissao: 'admin.ver', plataforma: true, componente: TelaEntrada },
    // Uso de IA (01/11): tokens e custo do Claude Code medidos no Mac; da instalação inteira, só o administrador da plataforma.
    { chave: 'uso-ia', permissao: 'admin.ver', plataforma: true, componente: UsoIa },
  ],
  // Lote de 19/10 (item 16): o convite pelo tipo, aberto também pela ficha do funcionário em Pessoas.
  dialogoConvite: ConviteModal,
  i18n,
};

export default modulo;
